// Emoji Directive, Usage:
//
// v-emoji="`:tada: Congrats!`"    Strings that contain emoji
// v-emoji="myVar"                 Variables that return strings that may contain emoji
//
// This directive disables no-restricted-syntax to allow for a deliberate assignment to innerHTML
// This is allowed because convertText thoroughly escapes HTML.
const convertEmojis = (el, binding, _vnode) => {
  // eslint-disable-next-line no-restricted-syntax
  el.innerHTML = Donut.Emoji.convertText(binding.value);
};

export default {
  mounted(el, binding, vnode) {
    convertEmojis(el, binding, vnode);
  },

  updated(el, binding, vnode) {
    if (binding.oldValue !== binding.value) {
      convertEmojis(el, binding, vnode);
    }
  },
};
